'use strict';

import {Helper} from "../helpers/Helper.js";

export default class FilterableCardsList {
	#block;
	#listWrapper;
	#itemsList;
	#items;
	#sortTypeSelect;
	#searchField;

	#pagination;
	#itemsPerPage;
	#pagesCount;
	#pagingCurrentPage;

	#isEditor;

	constructor(listWrapper, isEditor = false) {
		this.#itemsList = [];
		this.#listWrapper = listWrapper;
		this.#block = listWrapper.parentElement;
		this.#sortTypeSelect = this.#block.querySelector('select.list_filter');
		this.#searchField = this.#block.querySelector('input.list_search');
		this.#items = this.#listWrapper.querySelectorAll('.list-item');

		this.#pagination = this.#listWrapper?.dataset?.pagination === 'true';
		this.#itemsPerPage = +this.#listWrapper?.dataset?.perPage;
		this.#itemsPerPage = this.#itemsPerPage === 0 ? this.#itemsList.length : this.#itemsPerPage || 9;
		this.#pagesCount = 1;

		this.#isEditor = isEditor;

		this.#pagingCurrentPage = 1;
	}

	initialize() {
		this.#addEvents();
		this.sort();
		this.updatePaging();
	}

	update() {
		setTimeout(() => {
			this.#pagination = this.#listWrapper?.dataset?.pagination === 'true';

			this.#itemsPerPage = +this.#listWrapper?.dataset?.perPage;
			this.#itemsPerPage = this.#itemsPerPage === 0 ? this.#itemsList.length : this.#itemsPerPage || 9;
			this.#pagesCount = Math.ceil(this.#itemsList.length / this.#itemsPerPage);

			if (this.#pagingCurrentPage > this.#pagesCount){
				this.#pagingCurrentPage = 1;
			}

			this.sort();
			this.search();
			this.updatePaging();
		}, 100)
	}

	#addEvents() {
		this.#block.addEventListener('change', (event) => {
			if (event.target === this.#sortTypeSelect) {
				this.sort('newest');
				this.sort();
				this.#pagingCurrentPage = 1;
				this.updatePaging();
			}
		});

		this.#block.addEventListener('input', (event) => {
			if (event.target === this.#searchField) {
				this.search();
				this.#pagingCurrentPage = 1;
				this.updatePaging();
			}
		})

		this.#block.addEventListener('click', (event) => {
			if (event.target.matches('.pagination-button') || event.target.closest('.pagination-button')) {
				event.preventDefault()
				const button = event.target.matches('.pagination-button') ? event.target : event.target.closest('.pagination-button');

				if (button.classList.contains('placeholder')) return;

				if (button.classList.contains('next')) {
					if (this.#pagingCurrentPage >= this.#pagesCount) return;
					this.#pagingCurrentPage++;
				} else if (button.classList.contains('prev')) {
					if (this.#pagingCurrentPage <= 1) return;
					this.#pagingCurrentPage--;
				} else {
					this.#pagingCurrentPage = +button?.dataset?.page || 1;
				}

				this.updatePaging();
			}
		})
	}

	generateCampaignsArray() {
		if (!this.#listWrapper) return;

		const list = [];

		let index = 0;
		for(const item of this.#items) {
			list.push({
				title: item?.dataset?.title || '',
				subtitle: item?.dataset?.subtitle || '',
				goal: +item?.dataset?.goal || 0,
				orders: +item?.dataset?.orders || 0,
				raised: +item?.dataset?.raised || 0,
				amount: +item?.dataset?.amount || 0,
				datetime: Helper.strtotime(item?.dataset?.datetime) || 0,
				hidden: false,
				hiddenByFilter: false,
				page: 1,
				index: index,
				element: item,
			});

			index ++;
		}

		this.#pagesCount = Math.ceil(list.length / this.#itemsPerPage);
		this.#itemsList = list;
	}

	sort(sortingType = '') {
		if(!sortingType) sortingType = this.#sortTypeSelect.value || '';

		if (!sortingType) return;

		const sortItems = this.#itemsList;

		if (sortingType === 'oldest') {
			sortItems.sort((a, b) => {
				let dateA = new Date(a.datetime);
				let dateB = new Date(b.datetime);
				return dateA - dateB;
			});
		} else if (sortingType === 'newest') {
			sortItems.sort((a, b) => {
				let dateA = new Date(a.datetime);
				let dateB = new Date(b.datetime);
				return dateB - dateA;
			});
		} else if (sortingType === 'raised-desc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.raised;
				let amountValueB = b.raised;
				return amountValueB - amountValueA;
			});
		} else if (sortingType === 'raised-asc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.raised;
				let amountValueB = b.raised;
				return amountValueA - amountValueB;
			});
		} else if (sortingType === 'goal-desc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.goal;
				let amountValueB = b.goal;
				return amountValueB - amountValueA;
			});
		} else if (sortingType === 'goal-asc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.goal;
				let amountValueB = b.goal;
				return amountValueA - amountValueB;
			});
		} else if (sortingType === 'orders-desc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.orders;
				let amountValueB = b.orders;
				return amountValueB - amountValueA;
			});
		} else if (sortingType === 'orders-asc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.orders;
				let amountValueB = b.orders;
				return amountValueA - amountValueB;
			});
		} else if (sortingType === 'amount-desc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.amount;
				let amountValueB = b.amount;
				return amountValueB - amountValueA;
			});
		} else if (sortingType === 'amount-asc') {
			sortItems.sort((a, b) => {
				let amountValueA = a.amount;
				let amountValueB = b.amount;
				return amountValueA - amountValueB;
			});
		} else if (sortingType === 'alphabetical') {
			sortItems.sort((a, b) => {
				let nameA = a.title;
				let nameB = b.title;

				const startsWithSymbolA = /^[^\s\w]/.test(nameA);
				const startsWithSymbolB = /^[^\s\w]/.test(nameB);

				if (startsWithSymbolA && !startsWithSymbolB) {
					return 1;
				} else if (!startsWithSymbolA && startsWithSymbolB) {
					return -1;
				} else {
					return nameA.localeCompare(nameB);
				}
			});
		} else if (sortingType === 'alphabetical-subtitle') {
			sortItems.sort((a, b) => {
				let nameA = a.subtitle;
				let nameB = b.subtitle;

				const startsWithSymbolA = /^[^\s\w]/.test(nameA);
				const startsWithSymbolB = /^[^\s\w]/.test(nameB);

				if (startsWithSymbolA && !startsWithSymbolB) {
					return 1;
				} else if (!startsWithSymbolA && startsWithSymbolB) {
					return -1;
				} else {
					return nameA.localeCompare(nameB);
				}
			});
		}

		this.#itemsList = sortItems;

		for(const index in this.#itemsList) {
			const itemObject = this.#itemsList[index];
			const item = this.#items[itemObject.index];

			this.#listWrapper.append(item);
		}
	}

	search() {
		const value = this.#searchField?.value || '';

		let hiddenItems = 0;

		for(const index in this.#itemsList) {
			const itemObject = this.#itemsList[index];
			const item = this.#items[itemObject.index];

			if (!this.#checkSearchValue(itemObject, value)) {
				item.classList.add('hidden');
				this.#itemsList[index].hidden = true;
				this.#itemsList[index].hiddenByFilter = true;

				hiddenItems++;
			} else {
				item.classList.remove('hidden');
				this.#itemsList[index].hidden = false;
				this.#itemsList[index].hiddenByFilter = false;
			}
		}

		if (hiddenItems === this.#itemsList.length) {
			this.#block.classList.add('results-not-found');
		} else {
			this.#block.classList.remove('results-not-found');
		}

		this.#pagesCount = Math.ceil((this.#itemsList.length - hiddenItems) / this.#itemsPerPage);
		this.sort(hiddenItems ===  0 ? '' : 'alphabetical');
	}

	#checkSearchValue(itemObject, searchValue) {
		const searchArray = [
			itemObject.title,
			itemObject.subtitle,
			itemObject.amount,
			itemObject.raised,
			itemObject.goal,
			itemObject.orders,
			itemObject.date,
		]

		return searchArray.some(value => {
			value += '';

			if (!value) return false;

			let v = value.toLowerCase().trim().split(/[\s_\\\/]+/).join('-');
			let s = searchValue.toLowerCase().trim().split(/[\s_\\\/]+/).join('-');

			return value === searchValue ||
				v === s ||
				v.startsWith(s) ||
				v.includes(s)
		})
	}

	updatePaging() {
		let i = 1;
		for(const index in this.#itemsList) {
			const itemObject = this.#itemsList[index];

			if (itemObject.hiddenByFilter) continue;

			const item = this.#items[itemObject.index];
			itemObject.page = Math.ceil(i / this.#itemsPerPage);
			itemObject.hidden = itemObject.page !== this.#pagingCurrentPage;

			if (itemObject.hidden) {
				item.classList.add('hidden')
			} else {
				item.classList.remove('hidden')
			}

			i++;
		}

		const paginationWrapper = this.#block.querySelector('.levcharity-pagination');

		if (!paginationWrapper) return;
		if (this.#pagesCount <= 1) {
			paginationWrapper.style.display = 'none'
		} else {
			paginationWrapper.style.display = '';
		}

		const buttonNext = paginationWrapper.querySelector('.pagination-button.next');
		const buttonPrev = paginationWrapper.querySelector('.pagination-button.prev');

		buttonNext.classList.remove('disabled')
		buttonNext.removeAttribute('disabled')

		buttonPrev.classList.remove('disabled')
		buttonPrev.removeAttribute('disabled')

		if (this.#pagingCurrentPage === 1){
			buttonPrev.classList.add('disabled')
			buttonPrev.setAttribute('disabled', true)
		} else if (this.#pagingCurrentPage === this.#pagesCount) {
			buttonNext.classList.add('disabled')
			buttonNext.setAttribute('disabled', true)
		}

		let showButtons = 'normal'

		if (this.#pagesCount > 6) {

			if (this.#pagingCurrentPage === 3){
				showButtons = 'first-4-last-2'
			} else if (this.#pagingCurrentPage === this.#pagesCount - 2){
				showButtons = 'first-2-last-4'
			} else if (this.#pagingCurrentPage > 3) {
				if (this.#pagesCount > this.#pagingCurrentPage + 2) {
					showButtons = 'first-middle-last'
				}
			}
		} else {
			let showButtons = 'normal'
		}

		const placeholders = [
			paginationWrapper.querySelector('.pagination-button.placeholder-1'),
			paginationWrapper.querySelector('.pagination-button.placeholder-2')
		];

		paginationWrapper.querySelectorAll('.pagination-button:not(.prev):not(.next):not(.placeholder)').forEach((button, index) => {
			let hideButton = false;
			if (showButtons === 'normal') {
				hideButton = index >= 3 && (this.#pagesCount > 6 ? index < this.#pagesCount - 3 : false)

				if (index === 3 && this.#pagesCount > 6) {
					button.before(placeholders[0]);
					placeholders[0].classList.remove('hidden');
				}

				if (index === 0) {
					button.before(placeholders[1]);
					placeholders[1].classList.add('hidden');
					if (this.#pagesCount <= 6){
						button.before(placeholders[0]);
						placeholders[0].classList.add('hidden');
					}
				}

			} else if(showButtons === 'first-middle-last') {
				hideButton = index > 0 && index < this.#pagesCount - 1 && (index < this.#pagingCurrentPage - 2 || index > this.#pagingCurrentPage)

				if (index === 2) {
					button.before(placeholders[0]);
					placeholders[0].classList.remove('hidden');
				}

				if (index === this.#pagesCount - 2) {
					button.before(placeholders[1]);
					placeholders[1].classList.remove('hidden');
				}
			} else if(showButtons === 'first-4-last-2') {
				hideButton = index > 3 && index < this.#pagesCount - 2;

				if (index === 4) {
					button.before(placeholders[0]);
					placeholders[0].classList.remove('hidden');
				}

				if (index === 0) {
					button.before(placeholders[1]);
					placeholders[1].classList.add('hidden');
				}
			} else if(showButtons === 'first-2-last-4') {
				hideButton = index > 1 && index < this.#pagesCount - 4

				if (index === this.#pagesCount - 4) {
					button.before(placeholders[0]);
					placeholders[0].classList.remove('hidden');
				}

				if (index === 0) {
					button.before(placeholders[1]);
					placeholders[1].classList.add('hidden');
				}
			}

			if (this.#pagingCurrentPage === index + 1) {
				button.classList.add('current')
			} else {
				button.classList.remove('current');
			}

			if (hideButton || this.#pagesCount <= index) {
				button.classList.add('hidden')
			} else {
				button.classList.remove('hidden')
			}
		});
	}
}
